/**
 * Снимок выбранных фильтров — только ради подписей.
 *
 * Источник правды по фильтрам один: адресная строка. Но в ней лежат id, а в поле
 * и в строке применённых фильтров должно быть «Клиент: Иван Иванов», а не
 * «Клиент: 123». Подписи берём из снимка последнего применения; нет снимка
 * (другая вкладка, чужая ссылка) — показываем значение как есть.
 *
 * sessionStorage, а не localStorage: фильтры живут ровно столько, сколько вкладка.
 */
const storageKey = (name) => `filters:${name}`;

export const saveFilterSnapshot = (name, options) => {
  try {
    const snapshot = options
      .filter((option) => option.value !== undefined && option.value !== null && option.value !== '')
      .map((option) => ({ name: option.name, value: option.value }));
    sessionStorage.setItem(storageKey(name), JSON.stringify(snapshot));
  } catch (error) {
    // Приватный режим или заблокированное хранилище — переживём без подписей.
  }
};

export const clearFilterSnapshot = (name) => {
  try {
    sessionStorage.removeItem(storageKey(name));
  } catch (error) {
    // см. выше
  }
};

/**
 * Значения для полей формы: из снимка, если он про то же самое, иначе сырые из адреса.
 */
export const readFilterValues = (name, urlFilters = {}) => {
  let snapshot = [];
  try {
    snapshot = JSON.parse(sessionStorage.getItem(storageKey(name)) || '[]');
  } catch (error) {
    snapshot = [];
  }

  const values = {};
  Object.entries(urlFilters).forEach(([field, raw]) => {
    const saved = snapshot.find?.((item) => item.name === field)?.value;
    const sameValue =
      saved !== null && typeof saved === 'object'
        ? String(saved?.value) === String(raw)
        : String(saved) === String(raw);
    values[field] = saved !== undefined && sameValue ? saved : raw;
  });

  return values;
};
